import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/matikka';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full border-t border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-95" data-mp="1lc1yr8r0kvp2">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-96" data-mp="1gauqz9ovfwie">
        <h2 className="self-start font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:sticky lg:top-24 lg:col-span-4" data-id="element-97" data-mp="2dzxtw90xqfjq">
          Usein kysytyt <em className="text-red-700" data-id="element-98" data-mp="241h074am3mtz">kysymykset</em>
        </h2>

        <div className="border-t border-slate-900/15 lg:col-span-8" data-id="element-99" data-mp="24433usudti6x">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.q} className="border-b border-slate-900/15" data-id="element-100" data-mp="no0cquindtdd" data-mpi={index}>
                <h3 data-id="element-101" data-mp="nq4otzqp9yoq">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="group flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-red-700/40" data-id="element-102" data-mp="phy05goxrvsb">
                    <span className="font-serif text-xl leading-snug text-slate-900 sm:text-2xl" data-id="element-103" data-mp="fm4jbl46pg4q">{faq.q}</span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-slate-900 bg-slate-900 text-stone-50' : 'border-slate-900/20 text-slate-900 group-hover:border-slate-900/50'}`} data-id="element-104" data-mp="6rq39gbty1kk">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-105" data-mp="3swtoqr8ggyuo" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-106" data-mp="3nzbrvz7pqa31">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-107" data-mp="3nys5a574axio">
                      <p className="max-w-2xl pb-7 pr-14 leading-relaxed text-slate-900/75" data-id="element-108" data-mp="2dfp09206l655">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}